import { z } from "zod";

const testResultStatusValues = ["Success", "Failure"] as const;

export const testResultStatusSchema = z.enum(testResultStatusValues);
